// app/src/Auth.jsx — sign-in screen.
//
// Social-first (Google / Apple / Facebook via Cognito federation) + email OTP +
// the manager-provisioned JOIN CODE path (passwordless custom auth, see
// TECHNICAL_SPEC §4.5). Social/email flows redirect to the Cognito hosted UI via
// crew.auth.signIn(provider); the join-code flow is wired in a later milestone.

function AuthButton({ onClick, children, primary }) {
  return (
    <button onClick={onClick} style={{
      width: '100%', padding: '13px 16px', marginBottom: 10, cursor: 'pointer',
      borderRadius: 'var(--radius-sm)', fontWeight: 700, fontSize: 14,
      fontFamily: 'var(--font-body)',
      border: primary ? 'none' : '1px solid var(--line)',
      background: primary ? 'var(--primary)' : 'var(--surface)',
      color: primary ? 'var(--primary-ink)' : 'var(--ink)',
    }}>{children}</button>
  );
}

function AuthScreen() {
  // Completes the OAuth round-trip when Cognito returns with ?code=...
  React.useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.has('code') || url.searchParams.has('error')) {
      window.crew.auth.completeSignIn()
        .then(() => { window.location.hash = '/board'; window.location.reload(); })
        .catch((e) => console.error('[auth] completeSignIn failed', e));
    }
  }, []);

  const signIn = (provider) => () => window.crew.auth.signIn(provider).catch((e) => console.error(e));
  // TODO(M1): join-code sign-in via Cognito custom auth (USER_AUTH / CUSTOM_AUTH).
  const joinCode = () => { window.location.hash = '/join'; };

  return (
    <div className="crew" style={{
      height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px', background: 'var(--bg)',
    }}>
      <div style={{ width: '100%', maxWidth: 360 }}>
        <img src="/icons/kanjo-crew-lockup-dark.svg" alt={t('app.name', 'Kanjo Crew')}
          style={{ width: 220, maxWidth: '78%', height: 'auto', display: 'block', margin: '0 0 18px' }} />
        <p style={{ color: 'var(--on-soft)', fontSize: 14, margin: '0 0 24px' }}>
          {t('auth.tagline', 'Your team, talking in every language.')}
        </p>

        <AuthButton primary onClick={signIn('Google')}>{t('auth.signin.google', 'Continue with Google')}</AuthButton>
        <AuthButton onClick={signIn('SignInWithApple')}>{t('auth.signin.apple', 'Continue with Apple')}</AuthButton>
        <AuthButton onClick={signIn('Facebook')}>{t('auth.signin.facebook', 'Continue with Facebook')}</AuthButton>
        <AuthButton onClick={signIn()}>{t('auth.signin.email', 'Continue with email')}</AuthButton>

        <div style={{ textAlign: 'center', marginTop: 8 }}>
          <button onClick={joinCode} style={{
            border: 'none', background: 'none', color: 'var(--primary)', fontWeight: 700,
            fontSize: 13, cursor: 'pointer', fontFamily: 'var(--font-body)',
          }}>{t('auth.signin.joincode', 'I have a join code')}</button>
        </div>
      </div>
    </div>
  );
}

Object.assign(window, { AuthScreen, AuthButton });
